/**
 * Leader-election resource id for `guest.db`. MUST match the id the leader
 * worker entry hosts (`turso-leader-worker-entry.web.ts`) — a mismatch elects two
 * independent leaders on the same file, which is the exact failure this whole
 * mechanism prevents, so the host validates it and throws.
 */
export const GUEST_LEADER_RESOURCE_ID = "turso:guest.db";

/**
 * Leader-election resource id for `actor.db`. A SEPARATE election from
 * `guest.db`: they are different OPFS files with different exclusive handles, so
 * they may be led by different tabs, and coupling them would let a failed
 * `actor.db` open take `guest.db`'s leadership down with it.
 *
 * The id names the FILE and nothing else. It used to embed a hash of the migrations, so a tab on
 * an older build and a tab on a newer one elected two leaders for one OPFS file. Tabs on different
 * builds now share one leader and converge on the newest schema (`updateSchema` on the proxied
 * connection).
 */
export const ACTOR_LEADER_RESOURCE_ID = "turso:actor.db";

/** The one on-disk actor database on native, in both signed-out and signed-in states. */
export const ACTOR_DATABASE_NAME = "actor.db";
